import { useState } from "react";
import { toast } from "sonner";
import { Pencil, Check, X } from "lucide-react";
import { api, coachHeaders, formatDateHeure } from "../lib/api";

const NoteEditor = ({ item, index, code, onSaved }) => {
  const [edit, setEdit] = useState(false);
  const [note, setNote] = useState(item?.note ?? "");
  const save = async () => {
    try {
      await api.put("/version/note", { hash: item?.hash, installed_at: item?.installed_at, note }, coachHeaders(code));
      toast.success("Note enregistrée"); setEdit(false); onSaved?.();
    } catch (e) { toast.error(e?.response?.data?.detail || "Enregistrement impossible"); }
  };
  if (!edit) {
    return (
      <div className="flex items-start gap-2">
        <p data-testid={`update-history-note-${index}`} className={`text-xs ${item?.note ? "text-chalk" : "italic text-dim"}`}>
          {item?.note || "Pas de note"}
        </p>
        <button data-testid={`update-history-edit-${index}`} onClick={() => { setNote(item?.note ?? ""); setEdit(true); }}
          aria-label="Modifier la note" className="shrink-0 text-dim transition-colors hover:text-lime">
          <Pencil className="h-3.5 w-3.5" />
        </button>
      </div>
    );
  }
  return (
    <div className="mt-1 flex items-center gap-2">
      <input data-testid={`update-history-input-${index}`} value={note} maxLength={200} autoFocus
        onChange={(e) => setNote(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") save(); }}
        placeholder="Ex. : ajout de l'heure limite"
        className="min-w-0 flex-1 rounded-lg border border-line bg-pitch px-2 py-1 text-sm text-chalk outline-none focus:border-lime" />
      <button data-testid={`update-history-save-${index}`} onClick={save} aria-label="Enregistrer" className="text-lime"><Check className="h-4 w-4" /></button>
      <button data-testid={`update-history-cancel-${index}`} onClick={() => setEdit(false)} aria-label="Annuler" className="text-dim"><X className="h-4 w-4" /></button>
    </div>
  );
};

export const UpdateHistory = ({ history, code, onSaved }) => {
  const items = Array.isArray(history) ? history : [];
  if (items.length === 0) return null;
  return (
    <div data-testid="update-history" className="mt-4 border-t border-line pt-3">
      <h3 className="text-xs font-semibold uppercase tracking-widest text-dim">Historique des mises à jour</h3>
      <ul className="mt-2 space-y-1">
        {items.map((h, i) => (
          <li key={`${h?.hash}-${h?.installed_at}`} data-testid={`update-history-item-${i}`} className="rounded-lg px-2 py-1.5 odd:bg-ink/40">
            <div className="flex flex-wrap items-baseline justify-between gap-x-3 text-sm">
              <span className={`font-mono ${i === 0 ? "text-lime" : "text-chalk"}`}>
                {h?.version ?? "?"} - {h?.hash ?? "?"}
                {i === 0 && <span className="ml-2 font-sans text-xs text-dim">(actuelle)</span>}
              </span>
              <span className="text-xs text-dim">{formatDateHeure(h?.installed_at)}</span>
            </div>
            <NoteEditor item={h} index={i} code={code} onSaved={onSaved} />
          </li>
        ))}
      </ul>
    </div>
  );
};
